import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { BrDateAdapter } from './utils/br-date-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {ContentHeaderComponent} from "./components/content-header/content-header.component";
import {BreadcrumbComponent} from "./components/breadcrumb/breadcrumb.component";
import {ContentHeaderDashComponent} from "./components/content-header-dash/content-header-dash.component";
import {PipesModule} from "../theme/pipes/pipes.module";
import {FormsModule} from "@angular/forms";
import {DialogErrorComponent} from "./components/dialog-error/dialog-error.component";
import {DialogErrorReloadComponent} from "./components/dialog-error-reload/dialog-error-reload.component";
import {DialogComponent} from "./components/dialog/dialog.component";
import {DnaSearchSelectComponent} from "./components/dna-search-select/dna-search-select.component";
import {DnaPaginatorComponent} from "./components/dna-paginator/dna-paginator.component";
import {DnaAlertComponent} from "./components/dna-alert/dna-alert.component";
import {DnaSnackBarService} from "./service/dna-snackbar.service";
import {DateMaskDirective} from "./directives/date-mask.directive";
import {DateValidityDirective} from "./directives/date-validity.directive";
import {MatSnackBar} from "@angular/material/snack-bar";
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from "ngx-mask";

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    RouterModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    NgxMaskDirective,
    NgxMaskPipe,
    PipesModule,
    FormsModule
  ],
  exports: [
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    ContentHeaderComponent,
    ContentHeaderDashComponent,
    BreadcrumbComponent,
    PipesModule,
    DialogErrorComponent,
    DialogErrorReloadComponent,
    DialogComponent,
    DnaSearchSelectComponent,
    DnaPaginatorComponent,
    DnaAlertComponent,
    DateMaskDirective,
    DateValidityDirective,
    FormsModule
  ],
  declarations: [
    ContentHeaderComponent,
    BreadcrumbComponent,
    ContentHeaderDashComponent,
    DialogErrorComponent,
    DialogComponent,
    DialogErrorReloadComponent,
    DnaSearchSelectComponent,
    DnaPaginatorComponent,
    DnaAlertComponent,
    DateMaskDirective,
    DateValidityDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    provideNgxMask(),
    // O MatNativeDateModule importado acima provê DateAdapter -> NativeDateAdapter.
    // Em módulo lazy esses providers caem no injector do módulo e sombreavam o
    // BrDateAdapter registrado no AppModule (injector raiz), então o calendário
    // voltava a formatar/interpretar datas no padrão nativo. Reprovendo aqui,
    // depois dos imports, o adapter pt-BR vale em todos os injectors.
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: BrDateAdapter },
    // Toasts no padrão SSO em TODOS os módulos (inclusive lazy):
    // o MatSnackBar é provido por módulo, então a ponte precisa estar aqui
    { provide: MatSnackBar, useClass: DnaSnackBarService },
  ]
})
export class SharedModule { }
